import { Card, CardContent, CircularProgress, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { $gray400 } from 'styles/colors';

const styles = {
	loader: {
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		color: $gray400
	},
	loaderText: {
		color: { $gray400 },
		marginTop: 20
	}
};
const KhawkLocationLoading = () => {
	const useStyles = makeStyles(styles);
	const classes = useStyles();
	return (
		<Card className={classes.loader}>
			<CardContent className={classes.loader}>
				<CircularProgress />
				<Typography variant='h5' className={classes.loaderText} color='textSecondary'>
					Loading your location...
				</Typography>
			</CardContent>
		</Card>
	);
};

export default KhawkLocationLoading;
